/** *************************************************************
 * Copyright (c) 2006 - 2020, Case Anywhere, LLC.
 * All rights reserved
 *
 * @author Brad Wetmore
 * Date: 08/06/2021
 *
 * @version 0.2
 * Revisions:
 * 08/06/2021 - BW - Initial Creation
 * 08/09/2021 - BW - Added: CASE_MENU_CASE_DETAIL_SELECTOR
 * 04/05/2022 - BW - Added: PAYMENT_SELECTOR
 * 10/17/2022 - BW - Added: DOCUMENT_UPLOAD_2_SELECTOR
 *
 *
 * Description/Purpose:
 * Case Menu Util
 ************************************************************** */


const COMMON = {
  CASE_MENU_CASE_DETAIL_SELECTOR: '#case_menu_case_detail',
  DOCUMENT_UPLOAD_SELECTOR: '#case_menu_document_upload',
  DOCUMENT_UPLOAD_2_SELECTOR: '#case_menu_document_upload_2',
  E_FILE_SELECTOR: '#case_menu_e_file',
  DOCUMENT_PRODUCTION_SELECTOR: '#case_menu_document_production_upload',
  DEPOSITION_UPLOAD_SELECTOR: '#case_menu_deposition_upload',
  HEARING_UPLOAD_SELECTOR: '#case_menu_hearing_upload',
  DATE_VIEW_SELECTOR: '#case_menu_date_view',
  CATEGORY_VIEW_SELECTOR: '#case_menu_category_view',
  DOCUMENT_PRODUCTION_VIEW_SELECTOR: '#case_menu_document_production_view',
  DEPOSITION_VIEW_SELECTOR: '#case_menu_deposition_view',
  HEARING_VIEW_SELECTOR: '#case_menu_hearing_view',
  FILE_EXPORT_SELECTOR: '#case_menu_file_export',
  MESSAGE_BOARD_SELECTOR: '#case_menu_message_board',
  MASTER_CALENDAR_SELECTOR: '#case_menu_master_calendar',
  CASE_CALENDAR_SELECTOR: '#case_menu_case_calendar',
  PERSONAL_CALENDAR_SELECTOR: '#case_menu_personal_calendar',
  SERVICE_LIST_SELECTOR: '#case_menu_service_list',
  ACCESS_LIST_SELECTOR: '#case_menu_access_list',
  FORM_SELECTOR: '#case_menu_form',
  PAYMENT_SELECTOR: '#case_menu_payment',
};

const CaseMenuUtil = {
};

export {
  CaseMenuUtil, COMMON,
};
